<template>
  <div v-if="!loggedIn" class="flex items-center gap-2 text-sm">
    <a :href="loginHref" class="text-muted-foreground hover:text-foreground transition-colors">{{ tt('登录', '登入') }}</a>
    <span class="text-border">/</span>
    <a :href="registerHref" class="text-brand font-medium hover:underline">{{ tt('注册', '註冊') }}</a>
  </div>
  <div v-else class="flex min-w-0 w-full items-center justify-between gap-2 text-sm">
    <a
      href="/user"
      class="inline-flex min-w-0 flex-1 items-center gap-1.5 font-medium text-foreground/80 hover:text-foreground transition-colors"
      :title="tt('进入用户中心', '進入用戶中心')"
    >
      <img
        v-if="avatar"
        :src="avatar"
        alt=""
        class="h-8 w-8 rounded-full object-cover shrink-0"
      />
      <svg
        v-else
        class="h-4 w-4 text-brand shrink-0"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        aria-hidden="true"
      >
        <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2" />
        <circle cx="12" cy="7" r="4" />
      </svg>
      <span class="truncate">{{ displayName }}</span>
    </a>
    <button
      type="button"
      class="text-muted-foreground hover:text-foreground transition-colors shrink-0"
      :disabled="loggingOut"
      @click="logout"
    >
      {{ tt('退出', '登出') }}
    </button>
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'
import { authEntryHref } from '../auth-login/authEntry.ts'
import { tt, i18nFetch } from '../../shared/i18n.ts'

const props = withDefaults(
  defineProps<{
    loggedIn?: boolean
    name?: string
    avatar?: string
  }>(),
  {
    loggedIn: false,
    name: '',
    avatar: '',
  },
)

const currentPath = typeof window === 'undefined' ? '/' : window.location.pathname + window.location.search
const loginHref = computed(() => authEntryHref('/auth/login', currentPath))
const registerHref = computed(() => authEntryHref('/auth/register', currentPath))
const loggingOut = ref(false)
const displayName = computed(() => (props.name && props.name.trim().length > 0 ? props.name : tt('用户中心', '用戶中心')))

async function logout() {
  if (loggingOut.value) {
    return
  }
  loggingOut.value = true
  try {
    const res = await i18nFetch('/bff/v1/webauth/logout', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: '{}',
    })
    if (res.ok) {
      try {
        localStorage.removeItem('tunshu_user')
        if (typeof BroadcastChannel !== 'undefined') {
          new BroadcastChannel('tunshu_auth').postMessage({ type: 'logout' })
        }
      } catch (e) {}
      window.location.reload()
      return
    }
  } catch {
    // 退出失败保持当前页；服务端会记 error 日志
  }
  loggingOut.value = false
}
</script>
